import { forwardRef } from 'react';
import type { InputNumberRef } from '@rc-component/input-number';
import { MUAInput } from './MUAInput';
import type { MUAInputProps } from './MUAInput';

/**
 * Props {@link KursInput} — identik dengan {@link MUAInputProps}.
 */
export type KursInputProps = MUAInputProps;

/**
 * DERIVATIF: Textbox untuk nilai Kurs.
 *
 * Spek **identik** dengan {@link MUAInput} (2 desimal, background biru muda,
 * tanpa stepper). Dipisah sebagai komponen tersendiri untuk:
 *
 * 1. Memperjelas semantik di tempat pemakaian (Kurs ≠ MUA — Kurs adalah
 *    rasio konversi, MUA adalah jumlah uang dalam mata uang asing).
 * 2. Memungkinkan pencabangan style/perilaku di masa depan tanpa breaking
 *    change pada call site (mis. jika Kurs perlu 4 desimal sementara MUA
 *    tetap 2 desimal).
 *
 * Pemakaian:
 * ```tsx
 * <KursInput value={kurs} onChange={setKurs} />
 * ```
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/textbox-pattern.md`
 */
export const KursInput = forwardRef<InputNumberRef, KursInputProps>(
  function KursInput(props, ref) {
    return <MUAInput ref={ref} {...props} />;
  }
);
